import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import SignIn from "layouts/authentication/sign-in";

// @mui icons
import DashboardIcon from "@mui/icons-material/Dashboard";
import QueueRoundedIcon from "@mui/icons-material/QueueRounded";
import AssignmentIcon from "@mui/icons-material/Assignment";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { ImportExportRounded } from "@mui/icons-material";
import DescriptionIcon from "@mui/icons-material/Description";
import AssessmentIcon from "@mui/icons-material/Assessment";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import PauseCircleIcon from "@mui/icons-material/PauseCircle";
import TableViewIcon from "@mui/icons-material/TableView";
import BarChartRoundedIcon from "@mui/icons-material/BarChartRounded";
import AssessmentRounded from "@mui/icons-material/AssessmentRounded";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import FormatTextdirectionRToLIcon from "@mui/icons-material/FormatTextdirectionRToL";
import NotificationsIcon from "@mui/icons-material/Notifications";
import PersonIcon from "@mui/icons-material/Person";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";

import CargoOrderPage from "./layouts/cargo_order/CargoOrderPage";
import ReportBody from "./layouts/report/ReportBody";
import ReportTotalBody from "./layouts/report/ReportTotalBody";
import PrivateRoute from "./middleware/PrivateRoute";
import DefinitionPage from "./layouts/definaition/definition_page";
import StoreCargoPage from "./layouts/store-cargo/StoreCargoPage";
import ReportBodyLicense from "./layouts/report/CargoLicense/ReportBodyLicense";
import WeightReferencePage from "./layouts/weight_reference/WeightReferencePage";
import FunctionRegistration from "./layouts/function_registration/FunctionRegistration";
import ReportFunctionRegistrationBody from "./layouts/report/FunctionRegistration/FunctionRegistrationBody";
import StopRegistration from "./layouts/stop_registration/StopRegistration";
import ReportStopRegistrationBody from "./layouts/report/StopRegistration/StopRegistrationBody";
import ImportsCargoReportListPage from "./layouts/report/ImportsCargo/ImportsCargoReportListPage";
import ImportLicenseCargoPage from "./layouts/import_license_cargo/ImportLicenseCargoPage";
import ImportCargoPage from "./layouts/import_cargo/ImportCargoPage";
import WeightBridgePage from "./layouts/weight-bridge/WeightBridgePage";
import ReportBodyWeightBridge from "./layouts/report/WeightBridge/ReportBodyWeightBridge";
import DashboardLicense from "./layouts/dashboard/dashboard_license";

const routes = [
  {
    type: "collapse",
    name: "داشبورد",
    key: "",
    icon: <DashboardIcon fontSize="small" />,
    route: "/",
    component: <PrivateRoute><Dashboard /></PrivateRoute>,
  },
  {
    type: "collapse",
    name: "تعاریف",
    key: "definition",
    icon: <QueueRoundedIcon fontSize="small" />,
    route: "/definition",
    component: <PrivateRoute><DefinitionPage /></PrivateRoute>,
  },
  // {
  //   type: "collapse",
  //   name: "صدور حواله بارگیری",
  //   key: "store-cargo",
  //   icon: <AssignmentIcon fontSize="small" />,
  //   route: "/store-cargo",
  //   component: <PrivateRoute><StoreCargoPage /></PrivateRoute>,
  // },
  // {
  //   type: "collapse",
  //   name: "ثبت وزن حواله",
  //   key: "store-reference-weight",
  //   icon: <LocalShippingIcon fontSize="small" />,
  //   route: "/store-reference-weight",
  //   component: <PrivateRoute><WeightReferencePage /></PrivateRoute>,
  // },
  // {
  //   type: "collapse",
  //   name: "ایمپورت حواله های صادره",
  //   key: "import-license-cargos",
  //   icon: <ImportExportRounded fontSize="small" />,
  //   route: "/import-license-cargos",
  //   component: <PrivateRoute><ImportLicenseCargoPage /></PrivateRoute>,
  // },
  // {
  //   type: "collapse",
  //   name: "گزارش حواله های صادره",
  //   key: "report-license",
  //   icon: <DescriptionIcon fontSize="small" />,
  //   route: "/report-license",
  //   component: <PrivateRoute><ReportBodyLicense /></PrivateRoute>,
  // },
  // {
  //   type: "collapse",
  //   name: "ایمپورت بارنامه",
  //   key: "import-cargos",
  //   icon: <DescriptionIcon fontSize="small" />,
  //   route: "/import-cargos",
  //   component: <PrivateRoute><ImportCargoPage /></PrivateRoute>,
  // },
  // {
  //   type: "collapse",
  //   name: "گزارشات صدور بارنامه",
  //   key: "function-registration-report",
  //   icon: <AssessmentIcon fontSize="small" />,
  //   route: "/function-registration-report",
  //   component: <PrivateRoute><ImportsCargoReportListPage /></PrivateRoute>,
  // },
  {
    type: "collapse",
    name: "ثبت کارکرد",
    key: "function-registration",
    icon: <FactCheckIcon fontSize="small" />,
    route: "/function-registration",
    component: <PrivateRoute><FunctionRegistration /></PrivateRoute>,
  },
  {
    type: "collapse",
    name: "ثبت توقف",
    key: "stop-registration",
    icon: <PauseCircleIcon fontSize="small" />,
    route: "/stop-registration",
    component: <PrivateRoute><StopRegistration /></PrivateRoute>,
  },
  {
    type: "collapse",
    name: "توزین باسکول",
    key: "Weight-Bridge",
    icon: <TableViewIcon fontSize="small" />,
    route: "/Weight-Bridge",
    component: <PrivateRoute><WeightBridgePage /></PrivateRoute>,
  },
  {
    type: "collapse",
    name: "گزارشات باسکول",
    key: "report-weight-bridge",
    icon: <AssessmentIcon fontSize="small" />,
    route: "/report-weight-bridge",
    component: <PrivateRoute><ReportBodyWeightBridge /></PrivateRoute>,
  },
  {
    type: "collapse",
    name: "گزارشات کارکرد",
    key: "report-function-registration",
    icon: <BarChartRoundedIcon fontSize="small" />,
    route: "/report-function-registration",
    component: <PrivateRoute><ReportFunctionRegistrationBody /></PrivateRoute>,
  },
  {
    type: "collapse",
    name: "گزارشات توقف",
    key: "report-stop-registration",
    icon: <AssessmentRounded fontSize="small" />,
    route: "/report-stop-registration",
    component: <PrivateRoute><ReportStopRegistrationBody /></PrivateRoute>,
  },
  {
    type: "collapse",
    name: "گزارشات تفصیلی",
    key: "reports",
    icon: <ReceiptLongIcon fontSize="small" />,
    route: "/reports",
    component: <PrivateRoute><ReportBody /></PrivateRoute>,
  },
  {
    type: "collapse",
    name: "گزارشات تجمیعی",
    key: "report-total",
    icon: <FormatTextdirectionRToLIcon fontSize="small" />,
    route: "/report-total",
    component: <PrivateRoute><ReportTotalBody /></PrivateRoute>,
  },
  {
    type: "collapse",
    name: "ثبت دستور بار",
    key: "cargo-order",
    icon: <NotificationsIcon fontSize="small" />,
    route: "/cargo-order",
    component: <PrivateRoute><CargoOrderPage /></PrivateRoute>,
  },
  {
    type: "collapse",
    name: "کاربران",
    key: "users",
    icon: <PersonIcon fontSize="small" />,
    route: "/users",
    component: <PrivateRoute><Tables /></PrivateRoute>,
  },
  {
    type: "collapse",
    name: "خروج از حساب",
    key: "sign-in",
    icon: <ExitToAppIcon fontSize="small" />,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
];

export default routes;
